var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.25 4.96466H7.40469V10.2506C7.40469 10.3193 7.46094 10.3756 7.52969 10.3756H8.46719C8.53594 10.3756 8.59219 10.3193 8.59219 10.2506V4.96466H9.75C9.85469 4.96466 9.9125 4.84435 9.84844 4.7631L8.09844 2.54747C8.08674 2.53253 8.0718 2.52045 8.05475 2.51214C8.03769 2.50383 8.01897 2.49951 8 2.49951C7.98103 2.49951 7.96231 2.50383 7.94525 2.51214C7.92819 2.52045 7.91326 2.53253 7.90156 2.54747L6.15156 4.76154C6.0875 4.84435 6.14531 4.96466 6.25 4.96466ZM13.7188 9.78185H12.7812C12.7125 9.78185 12.6562 9.8381 12.6562 9.90685V12.3131H3.34375V9.90685C3.34375 9.8381 3.2875 9.78185 3.21875 9.78185H2.28125C2.2125 9.78185 2.15625 9.8381 2.15625 9.90685V13.0006C2.15625 13.2772 2.37969 13.5006 2.65625 13.5006H13.3438C13.6203 13.5006 13.8438 13.2772 13.8438 13.0006V9.90685C13.8438 9.8381 13.7875 9.78185 13.7188 9.78185Z",
          fill: "black",
          "fill-opacity": "0.88",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }